import { Link, useNavigate } from "react-router-dom";
import logo from './images/logo.jpeg';
import './Navbar.css';
import { useState, useEffect, useMemo, useCallback } from "react";
import api from "../services/api";
import { usePatologia } from "../context/PatologiaContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faUser } from "@fortawesome/free-solid-svg-icons";
import logo4 from './images/LOGO4.png';
import { useZona } from "../context/ZonaContext";
import Swal from "sweetalert2";
import { useAuthContext } from "../context/authContext";
import { PERMISSIONS } from "../config/permissions";

export const NavbarV2 = () => {
  const [nombreUsuario, setNombreUsuario] = useState("");
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isSettingsMenuActive, setIsSettingsMenuActive] = useState(false);
  const [suppressDropdowns, setSuppressDropdowns] = useState(false);

  const [patologias, setPatologias] = useState([]);
  const { patologiaActiva, setPatologiaActiva } = usePatologia();
  const [listaPatologias, setListaPatologias] = useState([]);
const { zonaActiva, cambiarZona } = useZona();
  const [zonasAsignadas, setZonasAsignadas] = useState([]);

  

  const navigate = useNavigate();
  const { can, modules } = useAuthContext();

  const enabledModuleCodes = useMemo(
    () => new Set((modules || []).map((modulo) => String(modulo.codigo || '').toLowerCase())),
    [modules]
  );

  const canSeeModule = useCallback((moduleCode) => {
    if (!moduleCode) return true;
    if (enabledModuleCodes.size === 0) return true;
    return enabledModuleCodes.has(String(moduleCode).toLowerCase());
  }, [enabledModuleCodes]);

  const canSubmenu = useCallback((submenuPermission) => {
    if (can(submenuPermission)) return true;
    return false;
  }, [can]);

  const buttonLinkStyle = {
    background: 'transparent',
    border: 'none',
    padding: '0.35rem 1rem',
    margin: 0,
    width: '100%',
    textAlign: 'left',
    cursor: 'pointer',
    color: 'inherit',
    font: 'inherit',
  };

  // Menús principales: visibilidad según permisos de submenús
  const canSeeDataMenu = [
    PERMISSIONS.SUBMENU_ADD_PERSONA,
    PERMISSIONS.SUBMENU_ADD_CONTACTOS,
    PERMISSIONS.SUBMENU_ADD_PAIS,
    PERMISSIONS.SUBMENU_ADD_TIPO_DOCUMENTO,
    PERMISSIONS.SUBMENU_ADD_TIPO_DOMICILIO,
    PERMISSIONS.SUBMENU_ADD_ESTADO,
    PERMISSIONS.SUBMENU_ADD_PATOLOGIA,
    PERMISSIONS.SUBMENU_ADD_SINTOMAS,
    PERMISSIONS.SUBMENU_ADD_COMORBILIDAD,
    PERMISSIONS.SUBMENU_ADD_ESTUDIOS,
    PERMISSIONS.SUBMENU_ADD_ATRIBUTOS,
    PERMISSIONS.SUBMENU_ZONAS_SANITARIAS,
    PERMISSIONS.SUBMENU_ZONAS_GEOGRAFICAS,
    PERMISSIONS.SUBMENU_AREAS_PROGRAMATICAS,
    PERMISSIONS.SUBMENU_SECTORES_SUBSECTORES,
    PERMISSIONS.SUBMENU_ADD_VACUNAS,
    PERMISSIONS.SUBMENU_ADD_MEDICACIONES,
    PERMISSIONS.SUBMENU_GRUPOS_ETARIOS,
    PERMISSIONS.SUBMENU_ESTABLECIMIENTOS_DIAGNOSTICO,
    PERMISSIONS.SUBMENU_INSTITUCIONES_SEGUIMIENTO_TRATAMIENTO,
    PERMISSIONS.SUBMENU_EVOLUCIONES_CLINICO_TERAPEUTICAS,
  ].some(can);

  const clinicalConfigurationSubmenus = [
    PERMISSIONS.SUBMENU_ADD_ESTADO_PATOLOGIA,
    PERMISSIONS.SUBMENU_ADD_SINTOMA_PATOLOGIA,
    PERMISSIONS.SUBMENU_ADD_COMORBILIDAD_PATOLOGIA,
    PERMISSIONS.SUBMENU_ADD_ESTUDIO_PATOLOGIA,
    PERMISSIONS.SUBMENU_ADD_ATRIBUTO_PATOLOGIA,
    PERMISSIONS.SUBMENU_ADD_VACUNAS_PATOLOGIA,
    PERMISSIONS.SUBMENU_ADD_MEDICACION_PATOLOGIA,
  ];
  const canSeeClinicalConfigurationMenu = clinicalConfigurationSubmenus.some(can);


  // Menú Reglas: solo mostrar si hay submenús visibles
  const reglasSubmenus = [PERMISSIONS.RULES_READ, PERMISSIONS.RULES_CREATE, PERMISSIONS.RULES_UPDATE];
  const canSeeReglasMenu = reglasSubmenus.some(can);

  // Menú Listados: solo mostrar si hay submenús visibles
  const listadosSubmenus = [PERMISSIONS.PATIENTS_READ];
  const canSeeListadosMenu = listadosSubmenus.some(can);

  // Menú Grafos: solo mostrar si hay submenús visibles
  const grafosSubmenus = [PERMISSIONS.GRAPHS_READ];
  const canSeeGrafosMenu = grafosSubmenus.some(can);

  // Menú Informe: solo mostrar si hay submenús visibles
  const informeSubmenus = [PERMISSIONS.REPORTS_READ];
  const canSeeInformeMenu = informeSubmenus.some(can);

  // Menú G.I.S.: solo mostrar si hay submenús visibles
  const gisSubmenus = [PERMISSIONS.GIS_READ];
  const canSeeGISMenu = gisSubmenus.some(can);

  

  // useEffect principal para cargar nombre, rol, patologías y zonas
 useEffect(() => {
  const nombre = localStorage.getItem("nombreUsuario");
  const idUsuario = localStorage.getItem("idUsuario");

  if (nombre) setNombreUsuario(nombre);

  if (idUsuario) {
    const fetchPatologiasUsuario = async () => {
      try {
        const res = await api.get(`/patologias-usuario/${idUsuario}`);
        setListaPatologias(res.data);

        // Primero revisa localStorage
        const patologiaLocal = localStorage.getItem("patologiaActiva");

        if (patologiaLocal) {
          setPatologiaActiva(patologiaLocal);
        } else if (res.data.length > 0) {
          const defaultPat = res.data.find(p => p.esDefault) || res.data[0];
          setPatologiaActiva(defaultPat.Nombre);
          localStorage.setItem("patologiaActiva", defaultPat.Nombre);
          localStorage.setItem("idPatologiaSeleccionada", defaultPat.idPatologia);
        }
      } catch (err) {
        console.error("Error al obtener patologías del usuario:", err);
      }
    };

    // 🔹 Zonas asignadas del usuario
    const fetchZonasAsignadas = async () => {
      try {
        const res = await api.get(`/usuarios/${idUsuario}/zonas-asignadas`);
        setZonasAsignadas(res.data);

        if (!zonaActiva && res.data.length > 0) {
          cambiarZona(res.data[0].Nombre); // usa el contexto
          localStorage.setItem("idZonaActiva", res.data[0].IdZonaSanitaria);
        }
      } catch (err) {
        console.error("Error al obtener zonas asignadas:", err);
      }
    };

    fetchPatologiasUsuario();
    fetchZonasAsignadas();
  }

  // 🔹 Todas las patologías
  const fetchPatologias = async () => {
    try {
      const response = await api.get(`/patologias`);
      setPatologias(response.data);
    } catch (error) {
      console.error("Error al obtener las patologías:", error);
    }
  };
  fetchPatologias();
}, []);

  // Cambio de patología
  const handlePatologiaChange = async (e) => {
    const nuevaPatologiaNombre = e.target.value;
    const seleccion = listaPatologias.find(p => p.Nombre === nuevaPatologiaNombre);
    const idUsuario = localStorage.getItem("idUsuario");

    if (!seleccion || !idUsuario) return;

    try {
      // Llamada PUT al backend para activar la nueva patología
      await api.put(`/patologias-usuario`, {
        idUsuario: parseInt(idUsuario),
        idPatologia: seleccion.idPatologia,
        esDefault: true
      });

      // Actualizar estado y localStorage
      setPatologiaActiva(seleccion.Nombre);
      localStorage.setItem("patologiaActiva", seleccion.Nombre);
      localStorage.setItem("idPatologiaSeleccionada", seleccion.idPatologia);
     // window.location.reload(); // 🔄 refresca la página
      // ✅ SweetAlert éxito
      Swal.fire({
        title: "Patología cambiada",
        text: `Patología activa cambiada a: ${seleccion.Nombre}`,
        
        icon: "success",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        timer: 2000,
      });
     // window.location.reload(); // 🔄 refresca la página
      
    } catch (error) {
      console.error("Error al cambiar patología activa:", error);
      Swal.fire({
        title: "Error",
        text: "No se pudo cambiar la patología activa. Intenta nuevamente.",
        icon: "error",
        confirmButtonColor: "#d33",
        confirmButtonText: "Cerrar",
      });
      window.location.reload(); // 🔄 refresca la página
    }
  };
 

  const Logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const toggleMenu = () => setIsMenuActive(!isMenuActive);
  const handleNavigation = (path) => {
    setSuppressDropdowns(true);
    navigate(path);
    setIsMenuActive(false);
    setIsSettingsMenuActive(false);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  return (
    <nav
      className={`navbar is-transparent ${suppressDropdowns ? 'navbar--dropdowns-closed' : ''}`}
      id="navegations"
      onMouseLeave={() => setSuppressDropdowns(false)}
    >
      <div className="navbar-brand d-flex align-items-center" style={{ backgroundColor: '#f5f5f5', width: '100%', borderBottom: '1px solid #ddd' }}>
        <Link to={'/'} className="d-flex align-items-center">
          <img src={logo4} alt="Logo secundario" />
         
        </Link>
        <div className={`navbar-burger burger ${isMenuActive ? 'is-active' : ''}`} onClick={toggleMenu} role="button" style={{ marginLeft: "auto" }}>
          <span></span><span></span><span></span>
        </div>
      </div>

      <div className={`navbar-menu ${isMenuActive ? 'is-active' : ''}`}>
        <div className="navbar-start">
          {/* Menú Carga de datos */}
          {canSeeDataMenu && <div className="navbar-item has-dropdown is-hoverable">
            <span className="navbar-link">Carga de datos</span>
            <div className="navbar-dropdown is-boxed">
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_PERSONA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addPersona")}>Cargar casos</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_CONTACTOS) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addContactos")}>Cargar contactos</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_PAIS) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addPais")}>Paises</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_TIPO_DOCUMENTO) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addTipoDocumento")}>Tipo de documentos</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_TIPO_DOMICILIO) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addTipoDomicilio")}>Tipos de domicilio</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_ESTADO) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addEstado")}>Estados</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_ESTADO) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addEstadoTratamiento")}>Estados Tratamiento</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_PATOLOGIA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addPatologia")}>Patologias</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_SINTOMAS) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addSintomas")}>Sintomas</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_COMORBILIDAD) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addComorbilidad")}>Comorbilidades</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_ESTUDIOS) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addEstudios")}>Estudios</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_ATRIBUTOS) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addAtributos") }>Atributos</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_ATRIBUTOS) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addDiagnostico") }>Diagnósticos</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ZONAS_SANITARIAS) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/zonas-sanitarias")}>Zonas sanitarias</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ZONAS_GEOGRAFICAS) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/zonas-geograficas")}>Zonas geograficas</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_AREAS_PROGRAMATICAS) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/areas-programaticas")}>Áreas programáticas</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_SECTORES_SUBSECTORES) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/sectores-subsectores")}>Sectores y subsectores</button>}
         {canSubmenu(PERMISSIONS.SUBMENU_ADD_VACUNAS) && <button
  type="button"
  className="navbar-item"
  style={buttonLinkStyle}
  onClick={() => handleNavigation("PrivateMainPage/addVacunas")}
>
  Vacunas
</button>}

{canSubmenu(PERMISSIONS.SUBMENU_ADD_MEDICACIONES) && <button
  type="button"
  className="navbar-item"
  style={buttonLinkStyle}
  onClick={() => handleNavigation("PrivateMainPage/addMedicaciones")}
>
  Medicaciones
</button>}

{canSubmenu(PERMISSIONS.SUBMENU_GRUPOS_ETARIOS) && <button
  type="button"
  className="navbar-item"
  style={buttonLinkStyle}
  onClick={() => handleNavigation("PrivateMainPage/addGruposEtarios")}
>
  Grupos etarios
</button>}

{canSubmenu(PERMISSIONS.SUBMENU_ESTABLECIMIENTOS_DIAGNOSTICO) && <button
  type="button"
  className="navbar-item"
  style={buttonLinkStyle}
  onClick={() => handleNavigation("PrivateMainPage/establecimientos-diagnostico")}
>
  Establecimientos de diagnóstico
</button>}

{canSubmenu(PERMISSIONS.SUBMENU_INSTITUCIONES_SEGUIMIENTO_TRATAMIENTO) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/instituciones-seguimiento-tratamiento")}>Instituciones de seguimiento de tratamiento</button>}

{canSubmenu(PERMISSIONS.SUBMENU_EVOLUCIONES_CLINICO_TERAPEUTICAS) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/evoluciones-clinico-terapeuticas")}>Evoluciones clínico-terapéuticas</button>}

            </div>
          </div>}

          {/* Menú Configuración de patologías */}
          {canSeeClinicalConfigurationMenu && <div className="navbar-item has-dropdown is-hoverable">
            <span className="navbar-link">Configuración de patologías</span>
            <div className="navbar-dropdown is-boxed">
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_ESTADO_PATOLOGIA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addEstadoPorPatologia")}>Estados por patologías</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_ESTADO_PATOLOGIA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addEstadoTratamientoPorPatologia")}>Estados Tratamiento por patologías</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_SINTOMA_PATOLOGIA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addSintomaPorPatologia")}>Síntomas por patologías</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_COMORBILIDAD_PATOLOGIA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addComorbilidadPorPatologia")}>Comorbilidades por patologías</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_ESTUDIO_PATOLOGIA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addEstudioPorPatologia")}>Estudios por patologías</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_ATRIBUTO_PATOLOGIA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addAtributoPorPatologia")}>Atributos por patologías</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_ATRIBUTO_PATOLOGIA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/addDiagnosticoPorPatologia")}>Diagnósticos por patologías</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_VACUNAS_PATOLOGIA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/AddVacunasPorPatologia")}>Vacunación por patologías</button>}
              {canSubmenu(PERMISSIONS.SUBMENU_ADD_MEDICACION_PATOLOGIA) && <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/AddMedicacionPorPatologia")}>Medicación por patologías</button>}
            </div>
          </div>}

          {/* Menú Reglas */}
          {canSeeModule('reglas') && canSeeReglasMenu && <div className="navbar-item has-dropdown is-hoverable">
            <span className="navbar-link">Reglas</span>
            <div className="navbar-dropdown is-boxed">
              <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/reglas")}>Gestión de Reglas</button>
            </div>
          </div>}

          {/* Menú Listados */}
          {canSeeModule('listados') && canSeeListadosMenu && <div className="navbar-item has-dropdown is-hoverable">
            <span className="navbar-link">Listados</span>
            <div className="navbar-dropdown is-boxed">
              <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/ListadoCasosContactos")}>Lista de personas</button>
            </div>
          </div>}

          {/* Menú Grafos */}
          {canSeeModule('grafos') && canSeeGrafosMenu && <div className="navbar-item has-dropdown is-hoverable">
            <span className="navbar-link">Grafos</span>
            <div className="navbar-dropdown is-boxed">
              <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/Grafos")}>Renderizado de grafos</button>
              <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/Relaciones")}>Ingresar relaciones</button>
              <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/AddTiposRelacion")}>Añadir tipos de relación</button>
              <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/AddFechasSeguimiento")}>Agregar fechas de seguimiento</button>
            </div>
          </div>}

          {canSeeModule('informe') && canSeeInformeMenu && <button type="button" className="navbar-item" style={{ background: 'transparent', border: 'none', padding: '0.35rem 0.75rem', cursor: 'pointer', color: 'inherit', font: 'inherit' }} onClick={() => handleNavigation("PrivateMainPage/Informe")}>Informe</button>}
          {canSeeModule('gis') && canSeeGISMenu && <button type="button" className="navbar-item" style={{ background: 'transparent', border: 'none', padding: '0.35rem 0.75rem', cursor: 'pointer', color: 'inherit', font: 'inherit' }} onClick={() => handleNavigation("PrivateMainPage/GIS")}>G.I.S.</button>}
          <button type="button" className="navbar-item" style={{ background: 'transparent', border: 'none', padding: '0.35rem 0.75rem', cursor: 'pointer', color: 'inherit', font: 'inherit' }} onClick={() => handleNavigation("PrivateMainPage/apachesuperset")}>Estadísticas</button>
         {/* <a className="navbar-item" onClick={() => handleNavigation("/Seguimiento")}>
  Seguimiento
</a>
 <a
  className="navbar-item"
  onClick={() => handleNavigation("/PrivateMainPage/ControlSeguimiento/")}
>
  Control por Persona
</a> */}
        </div>

        <div className="navbar-end" style={{ display: 'flex', alignItems: 'center', gap: '20px', paddingTop: '0.15rem', paddingBottom: '0.15rem' }}>
          {/* Select de patología */}
         {listaPatologias.length > 0 && (
  <select
    value={patologiaActiva || ""}
    onChange={handlePatologiaChange}
    style={{
      marginLeft: "1rem",
      marginTop: "0",
      padding: "0.35rem 0.7rem",
      fontSize: "0.95rem",
      borderRadius: "6px",
      border: "1px solid #ccc",
      backgroundColor: "#f9f9f9",
      cursor: "pointer",
      minHeight: '36px'
    }}
  >
    {listaPatologias.map((p) => (
      <option key={p.idPatologia} value={p.Nombre}>
        {p.Nombre}
      </option>
    ))} 
  </select>
)}

 {/* Select de zona */}
{zonasAsignadas.length > 0 && (
  <select
    value={zonaActiva || ""}
    onChange={async (e) => {
      const nuevaZonaNombre = e.target.value;
      const zonaSeleccionada = zonasAsignadas.find(
        (z) => z.Nombre === nuevaZonaNombre
      );
      const idUsuario = localStorage.getItem("idUsuario");

      if (!zonaSeleccionada || !idUsuario) return;

      try {
        // Llamada al backend para activar la nueva zona
        await api.put(`/usuarios/cambiar-zona-sanitaria`, {
          IdUsuario: idUsuario,
          IdZonaSanitaria: zonaSeleccionada.IdZonaSanitaria,
        });

        // Actualizar contexto y localStorage
        cambiarZona(zonaSeleccionada.Nombre);
        localStorage.setItem("idZonaActiva", zonaSeleccionada.IdZonaSanitaria);

        // ✅ SweetAlert2 de éxito
        Swal.fire({
          title: "Zona cambiada",
          text: `Zona activa cambiada a: ${zonaSeleccionada.Nombre}`,
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Aceptar",
          timer: 2000,
        }).then(() => {
  // 🔄 Refrescar una sola vez después del cambio exitoso
//  window.location.reload();
});
      } catch (error) {
        console.error("Error al cambiar zona activa:", error);

        // ❌ SweetAlert2 de error
        Swal.fire({
          title: "Error",
          text: "No se pudo cambiar la zona activa. Intenta nuevamente.",
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: "Cerrar",
        });
      }
    }}
    style={{
      marginLeft: "0.5rem",
      marginTop: "0",
      padding: "0.35rem 0.7rem",
      fontSize: "0.95rem",
      borderRadius: "6px",
      border: "1px solid #ccc",
      backgroundColor: "#f9f9f9",
      cursor: "pointer",
      minHeight: '36px'
    }}
  >
    {zonasAsignadas.map((z) => (
      <option key={z.IdZonaSanitaria} value={z.Nombre}>
        {z.Nombre}
      </option>
    ))}
  </select>
)}


          {/* Mensaje bienvenida */}
          {nombreUsuario && (
            <div style={{ backgroundColor: '#f0f4ff', padding: '0 18px', borderRadius: '30px', fontFamily: "'Poppins', 'Segoe UI', Roboto, sans-serif", boxShadow: '0 2px 6px rgba(0,0,0,0.08)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, fontSize: '0.98rem', color: '#1a1a1a', letterSpacing: '0.4px', lineHeight: 1.2, marginTop: '0', marginRight: '2rem', minHeight: '36px' }}>
              Bienvenido, {nombreUsuario}
            </div>
          )}

          {/* Logout */}
          <div className="field is-grouped" style={{ display: 'flex', alignItems: 'center', margin: 0, padding: 0, lineHeight: 1 }}>
            <button
              onClick={Logout}
              aria-label="Logout"
              title="Logout"
              style={{
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                padding: '0.35rem 0.5rem',
                margin: 0,
                lineHeight: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '36px'
              }}
            >
              <FontAwesomeIcon icon={faUser} style={{ verticalAlign: 'middle', lineHeight: 1 }} size="1x" />
            </button>
          </div>

          {/* Crear cuenta / Administración de usuarios */}
          {(canSubmenu(PERMISSIONS.SUBMENU_CREAR_PERFIL) || canSubmenu(PERMISSIONS.USERS_READ)) && (
            <div
              className={`navbar-item has-dropdown ${isSettingsMenuActive ? 'is-active' : ''}`}
              style={{ marginLeft: '-10px', padding: 0, display: 'flex', alignItems: 'center', minHeight: '36px' }}
            >
              <button
                type="button"
                className="navbar-link is-arrowless"
                style={{ minHeight: '36px', width: '36px', padding: 0, background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                aria-expanded={isSettingsMenuActive}
                onClick={() => setIsSettingsMenuActive((prev) => !prev)}
              >
                <FontAwesomeIcon icon={faCog} />
              </button>
              <div className="navbar-dropdown is-right is-boxed">
                {canSubmenu(PERMISSIONS.SUBMENU_CREAR_PERFIL) && (
                  <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/crear-perfil")}>
                    Crear perfil
                  </button>
                )}
                {canSubmenu(PERMISSIONS.USERS_READ) && (
                  <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/administracion-usuarios")}>
                    Administración de Usuarios
                  </button>
                )}
                <button type="button" className="navbar-item" style={buttonLinkStyle} onClick={() => handleNavigation("PrivateMainPage/register")}>
                  Crear Cuenta
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};
